// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 939) return "static/chunks/939-454ef638f44d6962.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2937":"eabe11fc","5279":"6c44d60f","9510":"d59bccd2"}[chunkId] || chunkId) + "." + {"1167":"01d2aefe0f3c9201","2937":"5e6f1007026be5ab","5279":"da30b7363ba5e5bf","5296":"b261bf6fb75b64e6","7229":"e48096545576c89d","7611":"8ce2a455ca036824","9302":"1484dfc6e86caf12","9510":"72a9be9c9c9d82e2"}[chunkId] + ".js";
};